/**
 * An array of option objects for ad hoc cashflow actions.
 * Each object contains a `value` and `label` property, both set to either "Contribution" or "Withdrawal".
 *
 * @type {{ value: string, label: string }[]}
 * @example
 * // Example usage:
 * // [{ value: "Contribution", label: "Contribution" }, { value: "Withdrawal", label: "Withdrawal" }]
 */
const AdHocOptions = ["Contribution", "Withdrawal"].map((type) => ({
  value: type,
  label: type,
}));

export default AdHocOptions;
